import { FaChevronDown } from "react-icons/fa6";

const FeatureCard = () => {
  return (
    <div className="bg-white">
      <div className="custom-container py-[65px]">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1  lg:gap-16 md:gap-8 gap-2 mt-[43px]">
          <div className="flex justify-center">
            <div className="lg:border-b-[8px] sm:border-b-[4px] border-b-[2px] border-[#7ABF5B]  font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-[#000] text-center">
              FEATURES
            </div>
          </div>

          <div className="flex justify-center">
            <div className="font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-[#000] text-center">
              SPECS & COMPS
            </div>
          </div>

          <div className="flex justify-center">
            <div className="font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-[#000] text-center">
              OFFERS
            </div>
          </div>
        </div>

        <div className="lg:mt-[78px] md:mt-[68px] sm:mt-[58px] mt-[38px] lg:px-[100px] md:px-[80px] sm:px-[50px] px-[10px]">
          <div className="border-[2px] border-[#000] px-[47px] bg-[#F2F2F2]  py-[34px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="border-[2px] border-[#000] px-[47px] bg-[#F2F2F2]  py-[34px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="border-[2px] border-[#000] px-[47px] bg-[#F2F2F2]  py-[34px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FeatureCard;
